/* RESPONSIBLE TEAM: team-proactive-support */
import ApplicationAdapter from 'embercom/adapters/application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'messenger_apps/get_a_demo/settings';
  },
});
